export const MEDIA_MOBILE = '(max-width: 991px)';
export const MEDIA_PHONE = '(max-width: 639px)';
export const MEDIA_TABLET = '(min-width: 640px) and (max-width: 991px)';
export const MEDIA_DESKTOP = '(min-width: 991px)';
export const MEDIA_DESKTOP_MAX = '(min-width: 1232px)';
export const MEDIA_TEST = '';
